module.exports = __webpack_public_path__ + "static/img/KY-HSJ.2406087.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/KY-HSJ.png
// module id = DsRV
// module chunks = 1